import type { ComponentProps } from 'react'

import { t } from 'i18next'

import type { Badge } from '@/components/ui'
import type { TProdutoStatusEnum, TProdutoTipoLegendaStatusEnum, TTipoProdutoEnum } from '@/types/produto'

export type TConfiguracaoPorStatusProduto = Record<
  TProdutoTipoLegendaStatusEnum,
  { variant: ComponentProps<typeof Badge>['variant'] }
>

export const obterConfiguracaoProduto = (urlPath: string): TConfiguracaoPorStatusProduto => {
  const isChile = urlPath.includes('/es-CL')
  if (isChile) {
    return {
      ReservadoPorProposta: { variant: 'warning' },
      Disponivel: { variant: 'success' },
      Indisponivel: { variant: 'destructive' },
      ReservadoPeloVendedor: { variant: 'warning' },
    }
  }

  return {
    ReservadoPorProposta: { variant: 'warning' },
    Disponivel: { variant: 'success' },
    Indisponivel: { variant: 'destructive' },
    ReservadoPeloVendedor: { variant: 'warning-dark' },
  }
}

type TDescricaoPorTipoProduto = Record<TTipoProdutoEnum, Record<TProdutoStatusEnum, string>>
export const obterDescricaoProduto = (tipoProduto: TTipoProdutoEnum, status: TProdutoStatusEnum) => {
  const descricaoProduto: TDescricaoPorTipoProduto = {
    Acessorio: {
      Disponivel: t('enums:produto_status.disponivel'),
      Indisponivel: t('enums:produto_status.indisponivel'),
      Reservada: t('enums:produto_status.reservada'),
      Vendida: t('enums:produto_status.vendida'),
    },
    Lote: {
      Disponivel: t('enums:produto_status.disponivel'),
      Indisponivel: t('enums:produto_status.indisponivel'),
      Reservada: t('enums:produto_status.reservada'),
      Vendida: t('enums:produto_status.vendida'),
    },
    Unidade: {
      Disponivel: t('enums:produto_status.disponivel'),
      Indisponivel: t('enums:produto_status.indisponivel'),
      Reservada: t('enums:produto_status.reservada'),
      Vendida: t('enums:produto_status.vendida'),
    },
    VagaPadrao: {
      Disponivel: t('enums:produto_status.disponivel'),
      Indisponivel: t('enums:produto_status.indisponivel'),
      Reservada: t('enums:produto_status.reservada'),
      Vendida: t('enums:produto_status.vendida'),
    },
    Planta: {
      Disponivel: t('enums:produto_status.disponivel'),
      Indisponivel: t('enums:produto_status.indisponivel'),
      Reservada: t('enums:produto_status.reservada'),
      Vendida: t('enums:produto_status.vendida'),
    },
  }
  return descricaoProduto[tipoProduto][status]
}
